import { type FC, type HTMLProps } from "react";
import { usePathname } from "next/navigation";
import { Link } from "next-view-transitions";
import { clsx } from "clsx";
import { capitalize } from "~/shared/utils";
import { Icon } from "../../widgets";
import { NavButtonProps } from "./NavButton.d";
import "./styles.scss";
const NavButton: FC<NavButtonProps & HTMLProps<HTMLAnchorElement>> = ({
  icon,
  href,
  text = capitalize(href.substring(1)),
  className,
  ref,
  ...props
}) => {
  const pathname = usePathname();
  const isActive = href.split("?")[0] === pathname || pathname === "/" && href.startsWith("/notes");
  return <Link {...props} href={href} ref={ref} className={clsx("nav-button", isActive && "nav-button--active", className)} aria-disabled={isActive}>
			<Icon icon={icon} className={clsx("nav-button__icon", isActive && "nav-button__icon--active")} />
			<p className={clsx("nav-button__text", isActive && "nav-button__text--active")}>
				{text}
			</p>
		</Link>;
};
export default NavButton;